import { EmissionLabelsSeparators } from '../hooks/use-efficiency-labels-separators';

import { EnergyManagementType } from '../types';

import { WLTPRangeValue, WltpEnergyEfficiency } from '../../../services/victor/trim-layer-details-response';
import { createEfficiencyValueString, findVehicleEmissionData } from './index';

interface CreateStandardFueltypeProps {
	energyEfficiency: WltpEnergyEfficiency;
	wltpRangeValue: WLTPRangeValue[];
	emissionLabelsSeparators: EmissionLabelsSeparators;
}

export function createStandardFueltype({
	energyEfficiency,
	wltpRangeValue,
	emissionLabelsSeparators
}: CreateStandardFueltypeProps) {
	const efficiencyDataCombined = (() => {
		const preferredTypes = [EnergyManagementType.Pure, EnergyManagementType.Sustaining, EnergyManagementType.Weighted];

		for (const type of preferredTypes) {
			const data = findVehicleEmissionData(wltpRangeValue, type);
			if (data.length > 0) {
				return data;
			}
		}

		return [];
	})();
	const emissionData = efficiencyDataCombined.find(emissionElement => emissionElement.valueType === 'CO2');
	const consumptionData = efficiencyDataCombined.find(emissionElement => emissionElement.valueType === 'CONSUMPTION');
	const efficiencyClassData = energyEfficiency?.classWltp;

	if (!emissionData || !consumptionData || !efficiencyClassData) return;

	const emission = createEfficiencyValueString(emissionData.value, emissionData.unit);
	const consumption = createEfficiencyValueString(consumptionData.value, consumptionData.unit);
	const efficiencyClass = createEfficiencyValueString(efficiencyClassData);

	const { energyConsumptionCombinedLabel, consumptionEmissionsSeparator, emissionLabel, efficiencyClassLabel } =
		emissionLabelsSeparators;

	return [
		energyConsumptionCombinedLabel,
		consumption,
		consumptionEmissionsSeparator,
		emissionLabel,
		emission,
		consumptionEmissionsSeparator,
		efficiencyClassLabel,
		efficiencyClass
	].join(' ');
}
